__turbopack_context__.v({
  "checkIcon": "styles-module-scss-module__pu2AZa__checkIcon",
  "infoButton": "styles-module-scss-module__pu2AZa__infoButton",
  "labelContainer": "styles-module-scss-module__pu2AZa__labelContainer",
  "optionContent": "styles-module-scss-module__pu2AZa__optionContent",
  "optionRow": "styles-module-scss-module__pu2AZa__optionRow",
});
